import { retry } from '@core/decorators/RetryDecorator'
import type { DebouncedFunc } from 'lodash-es'
import { throttle } from 'lodash-es'
import { INSTANCE as DeviceManager } from './DeviceManager'
import { INSTANCE as DevicePullUpTaskManager } from '@core/DevicePull/DevicePullUpTaskManager'
import type { AxiosResponse } from 'axios'
import type { RemoteServiceResponse } from '@/netadapters/EndpointAdapter'
import { HTTP_STATUS_OK } from '@/netadapters/AbsNetAdapter'

// 设备是默认5分钟没有流量互通就关闭端口服务
const DEFAULT_NOTIFICATION_INTERVAL = 60 * 1000
const KEEP_CONNECT_SERVICE_ID = '100006'
const SERVICE_DEFINITION_NOT_FOUND = 'SERVICE_DEFINITION_NOT_FOUND'

class DeviceConnectionKeeper {
  #deviceConnectionKeeperMap = new Map<string, DebouncedFunc<(deviceId: string) => Promise<void>>>()

  static validateResult(result: unknown) {
    return (
      (result as AxiosResponse<RemoteServiceResponse>)?.data.statusCode === HTTP_STATUS_OK ||
      (result as AxiosResponse<RemoteServiceResponse>)?.data.code === SERVICE_DEFINITION_NOT_FOUND
    )
  }

  keepDeviceConnectById(deviceId: string) {
    const keepDeviceConnectThrottleFunction =
      this.#deviceConnectionKeeperMap.get(deviceId) ||
      throttle(
        async (deviceId: string) => {
          try {
            console.log(
              `[DeviceConnectionKeeper] ${new Date().toLocaleString()} invoke api notifyDeviceToStayConnected`
            )

            await this.notifyDeviceToStayConnected(deviceId)
          } catch (error) {
            console.log(
              `[DeviceConnectionKeeper] ${new Date().toLocaleString()} `,
              '保持端口服务开启失败 直接拉起设备',
              error
            )

            DevicePullUpTaskManager.pullUpDevice({ deviceId }, undefined, false, false)
          }
        },
        DEFAULT_NOTIFICATION_INTERVAL,
        { leading: true, trailing: false }
      )

    keepDeviceConnectThrottleFunction(deviceId)
    this.#deviceConnectionKeeperMap.set(deviceId, keepDeviceConnectThrottleFunction)
  }

  @retry(DeviceConnectionKeeper.validateResult)
  private async notifyDeviceToStayConnected(deviceId: string) {
    const device = DeviceManager.getDeviceById(deviceId)

    try {
      const result = await device?.callService(KEEP_CONNECT_SERVICE_ID, {}, {})

      console.log(`[DeviceConnectionKeeper] ${new Date().toLocaleString()} `, '通知设备保持开启端口', result)

      return result
    } catch (error) {
      console.log(`[DeviceConnectionKeeper] ${new Date().toLocaleString()} `, '通知设备保持开启端口 失败', error)

      return undefined
    }
  }
}

const INSTANCE = new DeviceConnectionKeeper()

export { INSTANCE }
